import { render, staticRenderFns } from "./SingleVisionImageWithoutWireframe.vue?vue&type=template&id=0b477b05&"
import script from "./SingleVisionImageWithoutWireframe.vue?vue&type=script&lang=js&"
export * from "./SingleVisionImageWithoutWireframe.vue?vue&type=script&lang=js&"
import style0 from "./SingleVisionImageWithoutWireframe.vue?vue&type=style&index=0&id=0b477b05&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports